import {
	FACEBOOK_PIXEL_CUSTOM_EVENT,
	FacebookPixelEventPayloadMap,
	FacebookPixelEventName,
} from '../types';

interface FacebookPixel {
	(...args: unknown[]): void;
}

declare global {
	interface Window {
		fbq: FacebookPixel;
	}
}

interface PixelEventData {
	content_type?: string;
	content_ids?: string[];
	content_name?: string;
	value?: number;
	currency?: string;
	num_items?: number;
}

const CUSTOM_PIXEL_EVENTS = new Set<FacebookPixelEventName>(
	Object.values(FACEBOOK_PIXEL_CUSTOM_EVENT),
);

const trackPixelEvent = (eventName: FacebookPixelEventName, eventData?: PixelEventData) => {
	try {
		window.fbq('track', eventName, eventData);
	} catch (error) {
		// eslint-disable-next-line no-console
		console.warn('Error tracking Facebook Pixel event:', error);
	}
};

const trackCustomPixelEvent = (eventName: FacebookPixelEventName, eventData?: PixelEventData) => {
	try {
		window.fbq('trackCustom', eventName, eventData);
	} catch (error) {
		// eslint-disable-next-line no-console
		console.warn('Error tracking custom Facebook Pixel event:', error);
	}
};

export const pixelEvent = <K extends keyof FacebookPixelEventPayloadMap>(
	eventName: K,
	payload?: FacebookPixelEventPayloadMap[K],
) => {
	if (window.fbq === undefined) {
		// eslint-disable-next-line no-console
		console.warn('Facebook Pixel not initialized');

		return;
	}

	if (CUSTOM_PIXEL_EVENTS.has(eventName)) {
		trackCustomPixelEvent(eventName, payload);
	} else {
		trackPixelEvent(eventName, payload);
	}
};
